module.exports = __webpack_public_path__ + "img/homepage2_01-seguros-venta-y-asesoria.552b0fbf.jpg";